const checks = {};

// Check if browser supports passive option for addEventListener
// See: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
const passiveEventListener = () => {
  if (Object.keys(checks).includes('passiveEventListener')) {
    return checks.passiveEventListener;
  }

  try {
    const options = {
      // eslint-disable-next-line getter-return
      get passive() {
        checks.passiveEventListener = true;
      },
    };

    window.addEventListener('test', options, options);
    window.removeEventListener('test', options, options);
  } catch (err) {
    checks.passiveEventListener = false;
  }

  return checks.passiveEventListener;
};

export default {
  passiveEventListener,
};
